/* eslint-disable arrow-body-style */

import _ from 'underscore';

export const getPersonaDecoratorStyles = ({ styleOverrides }) => () => {
  return {
    container: _.extend({
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px',
    }, styleOverrides.personaDecoratorContainer),
    picture: _.extend({
      width: '32px',
      height: '32px',
      borderRadius: '50%',
    }, styleOverrides.personaDecoratorPicture),
    nameLabel: _.extend({
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: 'bold',
      color: '#323130',
    }, styleOverrides.personaDecoratorNameLabel),
    sponsoredLabel: _.extend({
      fontSize: '10px',
      color: '#323130',
    }, styleOverrides.personaDecoratorSponsoredLabel),
  };
};
